import * as yup from 'yup';
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const mobileRegex = /^[6-9]\d{9}$/; 

export const validationSchema = yup.object().shape({
  emailId: yup
    .string()
    .required('Email or Mobile Number is required')
    .test(
      'email-or-mobile',
      'Enter a valid Email or Mobile Number',
      value => {
        if (!value) return false;
        return emailRegex.test(value) || mobileRegex.test(value);
      }
    ),

});
